import { StatusProcessamentoIA } from "@workflow/types";
import { ChartConfig } from "@/components/ui/chart";

/** Cores compartilhadas entre o donut de status e o gráfico "por tipo" — mesmo padrão do domínio de notificações. */
export const STATUS_PROCESSAMENTO_CHART_CONFIG = {
  [StatusProcessamentoIA.CONCLUIDO]: { label: "Sucesso", color: "#10b981" },
  [StatusProcessamentoIA.FALHA]: { label: "Falha", color: "#ef4444" },
  [StatusProcessamentoIA.PENDENTE]: { label: "Pendente", color: "#f59e0b" },
} satisfies ChartConfig;
